<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>{{ title }}</h3>
      <el-form
        size="mini"
        ref="videoForm"
        :model="videoInfo"
        :rules="rules"
        label-width="120px"
        style="width: 50%"
      >
        <el-form-item label="视频名称" prop="videoName">
          <el-input
            type="text"
            v-model="videoInfo.videoName"
            placeholder="请输入视频名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否推荐" prop="recommend">
          <el-select v-model="videoInfo.recommend" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频分类" prop="videoType">
          <el-select v-model="videoInfo.videoType" aria-placeholder="请选择" clearable>
            <el-option
              v-for="(item, index) in categoryList"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传视频">
          <el-upload
            drag
            action="https://adminapi.ci-ads.com/api/movie/upload/file"
            style="display: inline-block; margin-left: 15px"
            class="upload-demo"
            :with-credentials="true"
            multiple
            :limit="1"
            accept=".mp4,.m3u8"
            :auto-upload="true"
            :headers="{ Authorization: token }"
            :show-file-list="true"
            ref="uploadVideo"
            :on-success="handleAvatarSuccess"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.mp4或.m3u8格式的视频文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频连接" prop="url">
          <el-input
            type="text"
            v-model="videoInfo.url"
            placeholder="请上传视频"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="播放时长(S)">
          <el-input
            type="text"
            v-model="videoInfo.playTime"
            placeholder="请输入播放时长"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传封面大图">
          <el-upload
            drag
            action="https://adminapi.ci-ads.com/api/movie/upload/file"
            style="display: inline-block; margin-left: 15px"
            class="upload-demo"
            :with-credentials="true"
            multiple
            :limit="1"
            ref="uploadLargeCover"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
            :auto-upload="true"
            :headers="{ Authorization: token }"
            :show-file-list="true"
            :on-success="handleAvatarSuccessImgLarge"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
          </el-upload>

          <el-image
            :src="videoInfo.videoImage"
            style="width: 100px"
            :preview-src-list="[videoInfo.videoImage]"
          ></el-image>
        </el-form-item>
        <el-form-item label="视频封面大图" prop="videoImage">
          <el-input
            type="text"
            v-model="videoInfo.videoImage"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传缩略图">
          <el-upload
            drag
            action="https://adminapi.ci-ads.com/api/movie/upload/file"
            style="display: inline-block; margin-left: 15px"
            class="upload-demo"
            :with-credentials="true"
            multiple
            :limit="1"
            ref="uploadThumbCover"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
            :auto-upload="true"
            :headers="{ Authorization: token }"
            :show-file-list="true"
            :on-success="handleAvatarSuccessImgThumb"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
          </el-upload>

          <el-image
            :src="videoInfo.videoImageThumb"
            style="width: 100px"
            :preview-src-list="[videoInfo.videoImageThumb]"
          ></el-image>
        </el-form-item>
        <el-form-item label="视频缩略图" prop="videoImageThumb">
          <el-input
            type="text"
            v-model="videoInfo.videoImageThumb"
            :disabled="true"
          ></el-input>
        </el-form-item>

        <el-form-item label="视频描述">
          <el-input
            type="textarea"
            v-model="videoInfo.description"
            placeholder="请输入视频描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="版权信息">
          <el-input
            type="text"
            v-model="videoInfo.copyrightInfo"
            placeholder="请输入版权信息"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="updateVideoInfo('videoForm')" v-if="videoId"
            >更新视频信息</el-button
          >
          <div v-else>
            <el-button type="info" @click="resetVideoInfo">重置表单</el-button>
            <el-button type="primary" @click="addVideo('videoForm')">添加视频</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      title: "",
      videoId: "",
      videoInfo: {
        copyrightInfo: "",
        description: "",
        playTime: 0,
        recommend: 0,
        url: "",
        videoImage: "",
        videoImageThumb: "",
        videoName: "",
        videoType: "",
      },
      fileList: [],
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      categoryList: [],
      rules: {
        videoName: [{ required: true, message: "请输入视频名称", trigger: "blur" }],
        recommend: [{ required: true, message: "请输选择是否推荐", trigger: "change" }],
        videoType: [{ required: true, message: "请选择视频分类", trigger: "change" }],
        url: [
          { required: true, message: "请上传视频", trigger: "change" },
          { type: "url", message: "请输入正确的视频链接", trigger: "blur" },
        ],
        videoImage: [
          { required: true, message: "请上传视频封面", trigger: "change" },
          { type: "url", message: "请输入正确的视频封面链接", trigger: "blur" },
        ],
        videoImageThumb: [
          { required: true, message: "请上传视频缩略图", trigger: "change" },
          { type: "url", message: "请输入正确的视频缩略图链接", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleAvatarSuccess(res) {
      if (res.code == 0) {
        this.videoInfo.url = res.data.url;
        this.$refs.uploadVideo.clearFiles();
      }
    },
    handleAvatarSuccessImgLarge(res) {
      if (res.code == 0) {
        this.videoInfo.videoImage = res.data.url;
        this.$refs.uploadLargeCover.clearFiles();
      }
    },
    handleAvatarSuccessImgThumb(res) {
      if (res.code == 0) {
        this.videoInfo.videoImageThumb = res.data.url;
        this.$refs.uploadThumbCover.clearFiles();
      }
    },
    getCategoryList() {
      axiosGet("/api/video/classify/list").then((res) => {
        if (res.code == 0) {
          this.categoryList = res.data;
        }
      });
    },
    async updateVideoInfo(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        axiosPost("/api/video/update", this.videoInfo, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "更新成功", type: "success" });
          }
        });
      }
    },
    async addVideo(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        axiosPost("/api/video/add", this.videoInfo, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "添加成功", type: "success" });
            this.$refs.videoForm.resetFields();
          }
        });
      }
    },
    resetVideoInfo() {
      this.$refs.videoForm.resetFields();
    },
  },
  mounted() {
    this.getCategoryList();
    this.videoId = this.$route.query.id;
    if (this.videoId) {
      this.title = "视频信息";
      axiosGet("/api/video/info", { id: this.videoId }).then((res) => {
        if (res.code == 0) {
          this.videoInfo = res.data;
        }
      });
    } else {
      this.title = "添加视频";
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/TvVideoManager/videoDetail.vue